export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/exam/updatedistrict',
                method: 'POST',
                body: payload,
               
            };
        },
        invalidatesTags: ['allDistricts'],
    })
